module.exports = __webpack_public_path__ + "img/1.469ffbd8.png";